import ListaObjetosConId from "../tipos/listaObjetosConId";
import { crearVariable, FIELD_NOMBRE } from "./variable";
import { TIPO_ORDEN_CUSTOM } from "../tipos/ordenListaObjetosConId";
import { createOrdenVariablesCustom } from "./ordenVariables";
import { compareAttrStrLowerCase } from "../../utils/sortUtils";

class ListaVariables extends ListaObjetosConId {
    constructor(objetos) {
        super(objetos, crearVariable);
    }

    /**
     * Crea una instancia concreta de la lista
     */
    createNewList() {
        return new ListaVariables();
    }

    getListaNombresYUnidad() {
        let res = [];
        this.list.forEach((v) => {
            let str = v.nombre;
            if (v.unidad) str += " (" + v.unidad + ")";
            res.push(str);
        });
        return res;
    }

    getListaNombres(incluirUnidad) {
        return incluirUnidad
            ? this.getListaNombresYUnidad()
            : this.getFieldValsArrays(FIELD_NOMBRE);
    }

    /**
     * Retorna una lista de variables filtradas segun los parametros de filtrado definidos en el argumento filtros.
     * No modifica la lista original.
     *
     * @param {import('./filtrosVariables').default} filtros
     * @returns {ListaVariables} Lista filtrada de variables
     */
    filtrar() {
        let res = new ListaVariables();
        this.list.forEach((est) => {
            res.add(est);
        });
        return res;
    }

    /**
     * Retorna una lista ordenada de variables segun los parametros dados en `ordenVariables`
     * No afecta el objeto original.
     *
     * @param {import('./ordenVariables').default} ordenVariables Definicion del orden de las variables
     * @returns {ListaVariables} Lista ordenada de variables
     */
    sort(ordenVariables) {
        if (!ordenVariables) ordenVariables = createOrdenVariablesCustom();
        if (ordenVariables.tipo === TIPO_ORDEN_CUSTOM)
            return this.sortCopyCustom(ordenVariables.ids, ListaVariables);
        return this.sortPorNombre();
    }

    /**
   * Retorna una lista de variables el nombre.
   * No afecta el objeto original.

   * @returns {ListaVariables} - Lista ordenada de variables
   */
    sortPorNombre() {
        return this.sortCopy((o1, o2) => {
            return compareAttrStrLowerCase(o1, o2, FIELD_NOMBRE);
        }, ListaVariables);
    }
}

export { ListaVariables as default };
